import { GET } from "../API";

export const getNumberOfReferralsAPICall = (onSuccess, onError) => {
    GET(`/api/v1/identity/users/number_of_referrals`, onSuccess, onError,);
}
